import { SxProps, Theme } from '@mui/material';

export const styles: Record<'title' | 'submit' | 'checkbox' | 'content', SxProps<Theme>> = {
  checkbox: {
    '& + &': {
      borderTop: (theme) => `1px solid ${theme.palette.gray['200']}`,
    },
    '&:hover': {
      background: (theme) => theme.palette.gray['100'],
    },
    '.MuiFormControlLabel-label': {
      flexGrow: 1,
    },
    borderRadius: '4px',
    margin: 0,
    minWidth: '296px',
    padding: 2,
    width: '100%',
  },
  content: {
    background: (theme) => theme.palette.gray['50'],
    borderRadius: '8px',
    overflow: 'hidden',
  },
  submit: {
    position: { sm: 'absolute' },
    right: (theme) => ({
      sm: theme.spacing(1),
      xxs: theme.spacing(2),
    }),
  },
  title: {
    marginX: 'auto',
    padding: (theme) => theme.spacing(1),
  },
};
